import { ResolvedField, resolvePath } from '../../../../lib/contentful/utils'
import { useResource } from './useResource'

export function useEntryField({ fieldPath }: { fieldPath?: string }): ResolvedField {
	const entry = useResource()

	if ('error' in entry) return entry

	if (!fieldPath) return { error: 'Field path is not set.' }

	const field = resolvePath(fieldPath, entry.data)

	if (!field) return { error: `Cannot find field at ${fieldPath}. Check the graphql query.` }

	return { data: field }
}
